import React, { useState } from 'react';
import {
  Box,
  Button,
  MenuItem,
  FormControl,
  Menu,
  Divider,
  Typography,
  IconButton,
} from '@mui/material';
import {
  KeyboardArrowDown,
  KeyboardArrowRight,
  KeyboardArrowLeft,
} from '@mui/icons-material';

const NestedActionSelect = ({ 
  value, 
  onChange, 
  laydownList, 
  sx, 
  size = "small", 
  disabled = false, 
  currentLaydownId 
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showSubmenu, setShowSubmenu] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowSubmenu(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setShowSubmenu(false);
  };

  const handleMenuItemClick = (actionValue, destinationId = null) => {
    let selectedValue = actionValue;
    if (destinationId) {
      selectedValue = {
        action: actionValue,
        destinationId: destinationId,
        destinationName: laydownList.find(item => item.id === destinationId)?.name,
        subactivityId: laydownList.find(item => item.id !== destinationId)?.id
      };
    }
    onChange(selectedValue);
    handleClose();
  };

  const handleIntersiteClick = () => {
    setShowSubmenu(true);
  };

  const handleBackClick = () => {
    setShowSubmenu(false);
  };

  const getDisplayValue = () => {
    if (!value) return 'Select Action';
    
    if (typeof value === 'object' && value.action) {
      switch (value.action) {
        case 2:
          return `Intersite movement Issued to ${value.destinationName}`;
        case 3:
          return `Intersite movement Received from ${value.destinationName}`;
        default:
          return `Intersite movement to ${value.destinationName}`;
      }
    }
    
    switch (value) {
      case 0:
        return 'Delivery';
      case 4:
        return 'Stock Adjustment';
      case 2:
        return 'Intersite Movement';
      case 3:
        return 'Intersite Movement';
      default:
        return 'Select Action';
    }
  };

  return (
    <FormControl fullWidth size={size}>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={disabled}
        endIcon={<KeyboardArrowDown />}
        sx={{
          justifyContent: 'space-between',
          textAlign: 'left',
          color: 'text.primary',
          borderColor: 'rgba(0, 0, 0, 0.23)',
          backgroundColor: 'white',
          textTransform: 'none',
          fontSize: '16px',
          height: 45,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          '&:hover': {
            borderColor: 'text.primary',
            backgroundColor: 'white',
          },
          '& .MuiButton-endIcon': {
            marginLeft: 'auto',
            flexShrink: 0,
          },
          ...sx
        }}
      >
        <Box
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flexGrow: 1,
            textAlign: 'left',
          }}
        >
          {getDisplayValue()}
        </Box>
      </Button>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            minWidth: anchorEl?.offsetWidth || 200,
            maxHeight: 300,
          }
        }}
      >
        {!showSubmenu ? (
          <>
            <Typography variant="body2" sx={{ px: 2, py: 1, fontWeight: 600, color: 'text.secondary' }}>
              Action Type
            </Typography>
            <Divider />
            
            <MenuItem 
              onClick={() => handleMenuItemClick(4)}
              sx={{ fontSize: '16px', py: 1.5 }}
            >
              Stock Adjustment
            </MenuItem>
            
            <MenuItem 
              onClick={handleIntersiteClick}
              sx={{ 
                fontSize: '16px', 
                py: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>Intersite Movement</span>
              <KeyboardArrowRight />
            </MenuItem>
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ px: 2, py: 1, fontWeight: 600, color: 'text.secondary', display: 'flex', alignItems: 'center' }}>
              <IconButton size="small" onClick={handleBackClick} sx={{ mr: 1, p: 0.5 }}>
                <KeyboardArrowLeft />
              </IconButton>
              Select Destination
            </Typography>
            <Divider />
            
            {laydownList && laydownList.length > 0 ? (
              laydownList
                .filter(laydown => laydown.id !== currentLaydownId)
                .length > 0 ? (
                laydownList
                  .filter(laydown => laydown.id !== currentLaydownId)
                  .map((laydown) => (
                    <MenuItem 
                      key={laydown.id}
                      onClick={() => handleMenuItemClick(2, laydown.id)}
                      sx={{ fontSize: '16px', py: 1 }}
                    >
                      {laydown.name}
                    </MenuItem>
                  ))
              ) : (
                <MenuItem disabled sx={{ fontSize: '16px', py: 1, fontStyle: 'italic' }}>
                  No other destinations available
                </MenuItem>
              )
            ) : (
              <MenuItem disabled sx={{ fontSize: '16px', py: 1, fontStyle: 'italic' }}>
                No destinations available
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </FormControl>
  );
};

export default NestedActionSelect;